import React from "react";
import PageHeader from "../../../../components/Common/PageHeader";

function GridHeader() {
  return <PageHeader title="Nota Fiscal - Remover Validação" />;
}

export default GridHeader;